import { persistReducer } from 'redux-persist'
import { createBlacklistFilter, createWhitelistFilter } from 'redux-persist-transform-filter'
import storage from 'redux-persist/lib/storage';

const authTransform = createBlacklistFilter(
  'auth', // which reducer
  ['error', 'isLoading', 'loggingIn'] // what not to save
)

const courseTransform = createWhitelistFilter(
  'course', // which reducer
  ['enrollmentsList'] // only persist enrollmentsList
)

export function persistRootReducer(reducer) {
  return persistReducer(
    {
      storage,
      key: 'root',
      transforms: [authTransform, courseTransform],
      whitelist: ['auth', 'podcast', 'course']
    },
    reducer
  )
}